import { env } from "../../env/env";
import { LogoDto } from "../../domain/BrandDataDto";
import { useRef, useState } from "react";
import { Drawer, Dropdown } from "antd";
import LogoCardMenu from "./LogoCardMenu";
import "./LogoCard.scss";
import { DownOutlined, MoreOutlined } from "@ant-design/icons";

export interface LogoCardProps {
  logo: LogoDto;
  editAltText: (logo: LogoDto) => void;
  deleteLogo: (logo: LogoDto) => void;
}

export default function LogoCard({
  logo,
  editAltText,
  deleteLogo
}: LogoCardProps) {
  const dropdownButton = useRef<HTMLButtonElement>(null);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);

  function hideDropdown() {
    if (isMenuVisible) {
      dropdownButton.current?.click();
    }
  }

  function onCloseMobileMenu() {
    setMobileMenuVisible(false);
  }

  return (
    <li key={logo.id} className={"logo"}>
      <Dropdown
        className={"desktop-design-menu more-btn-ops"}
        open={isMenuVisible}
        placement="bottomRight"
        overlay={
          <LogoCardMenu
            closeMenu={hideDropdown}
            logo={logo}
            deleteLogo={deleteLogo}
            editAltText={editAltText}
          />
        }
      >
        <MoreOutlined ref={dropdownButton} onClick={() => { setMenuVisible(!isMenuVisible) }}/>
      </Dropdown>

      <div className={"mobile-design-menu more-btn-ops"}>
        <MoreOutlined onClick={() => { setMobileMenuVisible(!isMobileMenuVisible) }}/>
        <Drawer
          placement={"bottom"}
          visible={isMobileMenuVisible}
          onClose={onCloseMobileMenu}
          closeIcon={<DownOutlined/>}
          className={"mobile-bottom-menu"}
          height={"178px"}
        >
          <h2 style={{ padding: '16px 20px', margin: 0, fontSize: '18px', lineHeight: '22px', fontWeight: 'bold', borderBottom: '1px solid #cfcfcf' }}>Edit Logo</h2>
          <LogoCardMenu
            closeMenu={hideDropdown}
            logo={logo}
            deleteLogo={deleteLogo}
            editAltText={editAltText}
            />
        </Drawer>
      </div>

      <div
        className={"img"}
        style={{ backgroundImage: `url("${env.s3Path}/${logo.path}")` }}
      />
    </li>
  );
}
